import produce from 'immer';
import _ from 'lodash';
import objFromArray from 'src/utils/objFromArray';
import moment from 'moment';

import {
  GET_ALL_LEAD,
  GET_ONE_LEAD,
  ADD_LEAD,
  UPDATE_LEAD,
  DELETE_LEAD,
  LAST_SEEN
} from 'src/actions/leadActions';
const initialState = {
  allIds: [],
  byId: {}
};
const leadReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_LEAD: {
      const { leads } = action.payload;
      return produce(state, draft => {
        draft.byId = objFromArray(leads);
        draft.allIds = Object.keys(draft.byId);
      });
    }
    case GET_ONE_LEAD: {
      const { lead } = action.payload;
      return produce(state, draft => {
        draft.byId[lead.id] = lead;
        if (!draft.allIds.includes(lead.id)) {
          draft.allIds.push(lead.id);
        }
      });
    }
    case ADD_LEAD: {
      const { lead } = action.payload;
      return produce(state, draft => {
        draft.byId[lead.id] = lead;
        if (!draft.allIds.includes(lead.id)) {
          draft.allIds.push(lead.id);
        }
      });
    }
    case LAST_SEEN: {
      const { leadId } = action.payload;
      return produce(state, draft => {
        if (draft.allIds.includes(leadId)) {
          draft.byId[leadId] = {
            ...draft.byId[leadId],
            last_seen: moment()
          };
        }
      });
    }
    case UPDATE_LEAD: {
      const { lead } = action.payload;

      return produce(state, draft => {
        draft.byId[lead.id] = lead;
        if (!draft.allIds.includes(lead.id)) {
          draft.allIds.push(lead.id);
        }
      });
    }
    case DELETE_LEAD: {
      const { id } = action.payload;

      return produce(state, draft => {
        draft.byId = _.omit(draft.byId, id);
        _.pull(draft.allIds, id);
      });
    }

    default: {
      return state;
    }
  }
};

export default leadReducer;
